import React from 'react';
import { Modal, Table, Button } from 'antd';
import { Employee, EmployeeKpiData } from './types';
import { getEditKpiColumns } from './KpiHelper';

interface EditKpiModalProps {
  isEditKpiModalOpen: boolean;
  handleCloseEditKpiModal: () => void;
  selectedEmployee: Employee | null;
  handleUpdateKpi: () => void;
  viewKpiData: EmployeeKpiData[];
  modalLoading: boolean;
  editKpiInput: Record<number, { target?: number; actual?: number; weight?: number; kpiId?: number; kpiQuestionaireId?: number }>;
  handleEditKpiInputChange: (id: number, field: 'target' | 'weight' | 'actual', value: number | null) => void;
}

const EditKpiModal: React.FC<EditKpiModalProps> = ({
  isEditKpiModalOpen,
  handleCloseEditKpiModal,
  selectedEmployee,
  handleUpdateKpi,
  viewKpiData,
  modalLoading,
  editKpiInput,
  handleEditKpiInputChange
}) => {

  const columns = getEditKpiColumns(editKpiInput, handleEditKpiInputChange);

  return (
    <Modal
      title={`Edit KPI for ${selectedEmployee?.firstName || ''} ${selectedEmployee?.lastName || ''}`}
      open={isEditKpiModalOpen}
      onCancel={handleCloseEditKpiModal}
      width={1400}
      className="add-kpi-modal"
      bodyStyle={{ height: 600 }}
      footer={
        <div className="flex justify-end gap-3">
          <Button key="cancel" className="addButton secondary" onClick={handleCloseEditKpiModal} disabled={modalLoading}>Cancel</Button>
          <Button key="submit" className="addButton" type="primary" onClick={handleUpdateKpi} disabled={modalLoading} loading={modalLoading}>Update</Button>
        </div>
      }
    >
      <Table
        columns={columns}
        dataSource={viewKpiData}
        loading={modalLoading}
        pagination={false}
        rowKey="kpiId"
        scroll={{ y: 500 }}
        bordered
        size="middle"
      />
      <div className="total-weight-container">
        Total : {Object.values(editKpiInput).reduce((sum, item) => sum + (item.weight || 0), 0).toFixed(0)} %
      </div>
    </Modal>
  );
};

export default EditKpiModal;
